import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
import { ADD_ASSETS_PREFIX } from '../http-context';

export const addAssetsPrefixInterceptor: HttpInterceptorFn = (request, next) => {
    if (!request.context.get(ADD_ASSETS_PREFIX)) {
        return next(request);
    }

    request = request.clone({
        url: environment.assetsUrl + request.url,
        responseType: 'text',
    });

    return next(request);
};
